import { render, staticRenderFns } from "./ListPostsFeed.vue?vue&type=template&id=6b3a43ae&"
import script from "./ListPostsFeed.vue?vue&type=script&lang=js&"
export * from "./ListPostsFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports